export const sailingCoords = [
  { name: 'Abbadon', coords: '-12, 12' },
  { name: 'Aerioth', coords: '18, 28' },
  { name: 'Asmar (East)', coords: '59, -1' },
  { name: 'Asmar (North)', coords: '57, -1' },
  { name: 'Asmar (South)', coords: '59, -3' },
  { name: 'Boar Isle', coords: '21, 13' },
  { name: 'Cabeiri', coords: '10, 12' },
  { name: 'Calamyr', coords: '-33, -90' },
  { name: 'Charanth', coords: '2, 4' },
  { name: 'Christmas Isle', coords: '16, 28' },
  { name: "Dragon's Cove", coords: '16, 19' },
  { name: 'Dragon Isle', coords: '20, 18' },
  { name: "Ensi's Isle", coords: '81, -71' },
  { name: 'Fairdale Docks', coords: '46, -10' },
  { name: 'Fucawee', coords: '20, 10' },
  { name: 'Ghost Ship', coords: '-7, -5' },
  { name: 'Haven', coords: '39, -40' },
  { name: 'Holgresh', coords: '42, -39' },
  { name: 'Ice Flows 1', coords: '12, 29' },
  { name: 'Ice Flows 2', coords: '21, 29' },
  { name: 'Queendom of Jewel', coords: '23, 17' },
  { name: "Kit'tay Isle", coords: '61, -71' },
  { name: 'Kobold Isle', coords: '22, 15' },
  { name: 'Lanerell', coords: '24, 15' },
  { name: 'Liku', coords: '36, -69' },
  { name: 'Mjharr', coords: '36, -62' },
  { name: "Mon'kay Isle", coords: '59, -60' },
  { name: 'Native Isles', coords: '65, -57' },
  { name: 'Northern Outpost', coords: '27, 29' },
  { name: 'Ottograd', coords: '56, 21' },
  { name: 'Rimaga', coords: '33, -52' },
  { name: 'Shanadan', coords: '8, -69' },
  { name: 'Sunken City', coords: '3, 2' },
  { name: 'Talis', coords: '2, 28' },
  { name: 'Trinlar', coords: '6, 11' },
  { name: 'Tsfaru', coords: '-49, 20' },
  { name: 'Valon (Kender Isle)', coords: '27, 12' },
  { name: 'Whitestorm', coords: '12, 12' },
];

export const balloonCoords = [
  { name: 'Cabeiri', coords: '10, 12' },
  { name: 'Whitestorm', coords: '12, 12' },
  { name: 'Wolvesdale', coords: '27, 26' },
  { name: 'Fenris', coords: '11, 20' },
  { name: 'Lanerell', coords: '25, 16' },
  { name: 'Asmar', coords: '58, -2' },
];

export const shipsCoords = [
  {
    name: 'Dwarf Ship',
    coords: '~-36, ~-66',
    description: 'A very large battleship can be seen below.',
  },
  {
    name: 'Ghost Ship',
    coords: '~-4, ~-4',
    description: 'An old and large ship can be seen below.',
  },
  {
    name: 'Pirate Ship',
    coords: '~20, ~10',
    description: 'A large ship can be seen below.',
  },
];

export const flyingCoords = [
  {
    name: 'Abbadon',
    coords: '-12, 12',
    description: 'A dormant volcanic island covered in a dense tropical forest is below.',
  },
  {
    name: 'Aerioth',
    coords: '18, 28',
    description: 'A snowy village lays against the frozen shore below your wings.',
  },
  {
    name: 'Aerioth Dead Fields',
    coords: '18, 29',
    description: 'A snowy field can be seen below.',
  },
  {
    name: 'Asmar City',
    coords: '58, -2',
    description: 'A large city lays before you.',
  },
  {
    name: 'Boar Island',
    coords: '21, 13',
    description: 'A small island is below you.',
  },
  {
    name: 'Cabeiri Beach',
    coords: '10, 12',
    description: 'The beach of Cabeiri is below you.',
  },
  {
    name: 'Cabeiri Square',
    coords: '9, 13',
    description: 'The small town of Cabeiri is far below you.',
  },
  {
    name: 'Calamyr',
    coords: '-33, -91',
    description: 'A field of ice and snow is below.',
  },
  {
    name: 'Charanth',
    coords: '2, 4',
    description: 'Something can be seen far below.',
  },
  {
    name: 'Christmas Island',
    coords: '16, 28',
    description: 'A valley of snow and ice line the icy coast.',
  },
  {
    name: 'Clouds',
    coords: '10, 13',
    description: 'Some white fluffy clouds are here.',
  },
  {
    name: 'DeathSpiral Mountains',
    coords: '25, 18',
    description: 'A mountain path is below you.',
  },
  {
    name: 'DeathSpiral Mountains',
    coords: '26, 19',
    description: 'Mountains can be seen under you.',
  },
  {
    name: 'DeathSpiral Mountains',
    coords: '26, 20',
    description: 'Mountains can be seen under you.',
  },
  {
    name: 'DeathSpiral Mountains',
    coords: '26, 22',
    description: 'Mountains can be seen under you.',
  },
  {
    name: 'DeathSpiral Mountains',
    coords: '26, 23',
    description: 'Mountains can be seen under you.',
  },
  {
    name: 'DeathSpiral Mountains',
    coords: '26, 24',
    description: 'Mountains can be seen under you.',
  },
  {
    name: "Dragon's Cove",
    coords: '15, 19',
    description: 'A small cove lays under your wings.',
  },
  {
    name: 'Dragon Isle',
    coords: '20, 18',
    description: 'A small tropical island is far below, a warm feeling flows though you as you look at it.',
  },
  {
    name: 'Dreyvold',
    coords: '55, -5',
    description: 'A sprawling emerald green forest lies below.',
  },
  {
    name: "Ensi's Isle",
    coords: '81, -71',
    description: 'A dense forest island lies below.',
  },
  {
    name: 'Fairdale City',
    coords: '54, -7',
    description: 'A massive city covers rolling hills.',
  },
  {
    name: 'Fairdale Harbor',
    coords: '46, -10',
    description: 'A harbor can be seen below.',
  },
  {
    name: 'Fenris Rainforest',
    coords: '10, 20',
    description: 'A thick tropical forest grows far below.',
  },
  {
    name: 'Fenris Square (Marrdan)',
    coords: '11, 21',
    description: 'The dead town of Marrdan lays below you.',
  },
  {
    name: 'Fenris Swamp',
    coords: '11, 20',
    description: 'The Fenris swamps can be seen.',
  },
  {
    name: 'Forest of Deception',
    coords: '10, 21',
    description: 'The Forest of Deception is far below your wings.',
  },
  {
    name: 'Fucawee',
    coords: '20, 10',
    description: 'A small island is below you.',
  },
  {
    name: 'Haven Docks',
    coords: '39, -40',
    description: 'The docks of Haven can be seen far below.',
  },
  {
    name: 'Haven Square',
    coords: '40, -40',
    description: 'The town of Haven lies below.',
  },
  {
    name: 'Kingdom of Hiemelia',
    coords: '27, 27',
    description: 'The Kingdom of Hiemelia is far below.',
  },
  {
    name: 'Holgresh',
    coords: '42, -39',
    description: 'An extremely cliffy island is below you.',
  },
  {
    name: 'Iceflows',
    coords: '12, 29',
    description: 'An icy land is far below you.',
  },
  {
    name: 'Iceflows',
    coords: '21, 28',
    description: 'An icy land is far below you.',
  },
  {
    name: 'Imladris',
    coords: '26, 21',
    description: 'A hidden city can be seen under you.',
  },
  {
    name: 'Queendom of Jewel',
    coords: '24, 17',
    description: 'The Jeweled Queendom can be seen from here.',
  },
  {
    name: "Kit'tay Isle",
    coords: '61, -71',
    description: 'A small tropical island is below.',
  },
  {
    name: 'Kobold Island',
    coords: '22, 15',
    description: 'Several small islands are below you, with one being bigger than the rest.',
  },
  {
    name: 'Native Isles',
    coords: '65, -57',
    description: 'A chain of several small islands can be seen below.',
  },
  {
    name: 'Lanerell',
    coords: '25, 16',
    description: 'The town of Lanerell is under your wings.',
  },
  {
    name: 'Lanerell Mountains',
    coords: '25, 17',
    description: 'A mountain path is below you.',
  },
  {
    name: 'Lanerell Forest',
    coords: '26, 16',
    description: 'A large dark forest is under you.',
  },
  {
    name: 'Liku',
    coords: '38, -69',
    description: 'A wide path cutting through a forest can be seen below.',
  },
  {
    name: 'Liku Docks',
    coords: '37, -69',
    description: 'Some docks and a populated area can be seen below.',
  },
  {
    name: 'Mjharr',
    coords: '36, -62',
    description: 'A small island is beneath your wings.',
  },
  {
    name: "Mon'kay Isle",
    coords: '59, -60',
    description: 'A small, heavily wooded island is below.',
  },
  {
    name: 'Northern Outpost',
    coords: '27, 28',
    description: 'A small village is underwing.',
  },
  {
    name: 'Ottograd',
    coords: '57, 21',
    description: 'A frozen town lies below.',
  },
  {
    name: 'Rimaga',
    coords: '33, -52',
    description: 'A tiny dot of an island on the sea below you.',
  },
  {
    name: 'Shanadan Castle',
    coords: '8, -68',
    description: 'A castle in the center of an island lies below. A fire burns atop the castle roof.',
  },
  {
    name: 'Shanadan Cliffs',
    coords: '8, -68',
    description: 'A black sandy beach can be seen under your wings.',
  },
  {
    name: 'Sunken City',
    coords: '3, 2',
    description: 'Something can be seen below.',
  },
  {
    name: 'Talis',
    coords: '2, 28',
    description: 'An island of ice is far below.',
  },
  {
    name: 'Trinlar',
    coords: '6, 11',
    description: 'A small island can be seen under your wings.',
  },
  {
    name: 'Tsfaru',
    coords: '-49, 20',
    description: 'A pillar of rocks and ice juts from the water.\fnA cave entrance exists.',
  },
  {
    name: 'Valon (Kender Isle)',
    coords: '27, 12',
    description: 'A small island lay underwing.',
  },
  {
    name: 'Whitestorm Desert',
    coords: '11, 15',
    description: 'A large desert lays underwing.',
  },
  {
    name: 'Whitestorm Desert',
    coords: '11, 16',
    description: 'A large desert lays underwing.',
  },
  {
    name: 'Whitestorm Desert',
    coords: '11, 17',
    description: 'A large desert lays underwing.',
  },
  {
    name: 'Whitestorm Desert',
    coords: '11, 18',
    description: 'A large desert lays underwing.',
  },
  {
    name: 'Whitestorm Desert',
    coords: '11, 19',
    description: 'A large desert lays underwing.',
  },
  {
    name: 'Whitestorm Docks',
    coords: '12, 12',
    description: 'The Whitestorm docks can be seen.',
  },
  {
    name: 'Whitestorm Forest',
    coords: '13, 13',
    description: 'A forest is below.',
  },
  {
    name: 'Whitestorm Square',
    coords: '12, 13',
    description: 'The city of Whitestorm can be seen from even this height.',
  },
  {
    name: 'Wolvesdale Landing',
    coords: '27, 26',
    description: 'A small landing can be seen far below.',
  },
  {
    name: 'Wolvesdale Mystic Forest',
    coords: '28, 26',
    description: 'A forest can be seen below.',
  },
  {
    name: 'Wolvesdale Town',
    coords: '26, 25',
    description: 'The town of Wolvesdale is beneath you.',
  },
  {
    name: 'Xenora',
    coords: '26, 17',
    description: 'The Queendom of Xenora is under you.',
  },
];
